import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/use-auth";
import { AppNavbar } from "@/components/AppNavbar";
import { HeroSection } from "@/components/HeroSection";
import { ValueProps } from "@/components/ValueProps";
import { HowItWorks } from "@/components/HowItWorks";
import { FeaturedDestinations } from "@/components/FeaturedDestinations";
import { FeaturesDeepDive } from "@/components/FeaturesDeepDive";
import { WaitlistSection } from "@/components/WaitlistSection";
import { FinalCTA } from "@/components/FinalCTA";
import { AppFooter } from "@/components/AppFooter";
import { PageMeta } from "@/components/PageMeta";

const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "TROOPN",
  alternateName: "Troopn",
  url: "https://troopn.com",
  logo: "https://troopn.com/troopn-logo.png",
  description:
    "Yearly time-off planner that pairs travelers with compatible partners, generates AI itineraries, and tracks shared expenses.",
  sameAs: [
    "https://www.instagram.com/troopn",
    "https://www.tiktok.com/@troopn",
    "https://twitter.com/troopn",
  ],
};

export default function Landing() {
  const { isAuthenticated, isLoading } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen">
      <PageMeta
        title="TROOPN — Yearly Time-Off Planner for Friend-Making Adventures"
        description="See your year, find your troop, plan the trip. AI-powered trip planning, travel calendars, festival discovery, and group expense tracking — built for working professionals."
        path="/"
        jsonLd={ORG_JSONLD}
        track={{ pageType: "landing" }}
      />
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <AppNavbar transparent />
      <main id="main-content">
        <HeroSection />
        <ValueProps />
        <HowItWorks />
        <FeaturesDeepDive />
        <FeaturedDestinations />
        <WaitlistSection />
        <FinalCTA />
      </main>
      <AppFooter />
    </div>
  );
}
